"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment = require("moment");
var React = require("react");
var react_hot_toast_1 = require("react-hot-toast");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var api_service_1 = require("../../../../api/api_service");
var button_component_1 = require("../../../../common/buttons/button_component");
var multi_selector_1 = require("../../../../common/checkbox/multi_selector");
var drop_down_component_1 = require("../../../../common/drop_down/drop_down_component");
var search_component_1 = require("../../../../common/search/search_component");
var text_filed_with_fromto_Daterange_1 = require("../../../../common/text_filed/text_filed_with_fromto_Daterange");
var appConstants_1 = require("../../../../constants/appConstants");
var menu_constants_1 = require("../../../../menuList/menu_constants");
var array_helpers_1 = require("../../../../utils/array_helpers");
var leavetracking_apicalls_1 = require("../../../field_exicutive/leave_tracking/leavetracking.apicalls");
var Pagenotfound_1 = require("../../../../ErrorBoundary/Pagenotfound");
var tabs_component_1 = require("../../../../common/tabs/tabs_component");
var routes_list_1 = require("../../../../routes/routes_list");
var tabs_data_1 = require("../../../../constants/tabs_data");
var pop_up_1 = require("../../../../common/modal/pop-up");
var config_action_1 = require("../../../../actions/config_action");
var route_path_1 = require("../../../../constants/route_path");
var BaggingLifeCycle = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var isHavingFeature = false;
    var labList = (0, react_redux_1.useSelector)(function (state) { return state.appConfigList.labList; });
    var stateList = (0, react_redux_1.useSelector)(function (store) { return store.appConfigList; }).stateList;
    var CashStatus = (0, react_redux_1.useSelector)(function (state) { return state.appConfigList.sample_status; });
    var features = (0, array_helpers_1.getAccessibleFeatures)(menu_constants_1.FEATURE_CONSTANTS.reports);
    var filteredTabs = (0, array_helpers_1.disableTabs)(tabs_data_1.TABS_DATA.BAGGING_LIFECYCLE_REPORT_TABS, features);
    var approvalManagSubRoutes = (0, array_helpers_1.getAccessibleRoutes)(menu_constants_1.FEATURE_CONSTANTS.reports, routes_list_1.LIFECYCLE_REPORT_SUB_ROUTES);
    var _a = React.useState(''), searchTerm = _a[0], setSearchTerm = _a[1];
    var _b = React.useState(''), bagbarcode = _b[0], setbagbarcode = _b[1];
    var _c = React.useState(new Date().toString()), startDate = _c[0], setStartDate = _c[1];
    var _d = React.useState(new Date().toString()), endDate = _d[0], setEndDate = _d[1];
    var _e = React.useState([]), filterSelectedStates = _e[0], setSelectedFilterStates = _e[1];
    var _f = React.useState([]), citiesData = _f[0], setCitiesData = _f[1];
    var _g = React.useState([]), filterSelectedCities = _g[0], setSelectedFilterCities = _g[1];
    var _h = React.useState(null), cashstatus = _h[0], SetcashStatus = _h[1];
    var _j = React.useState(false), open = _j[0], setOpen = _j[1];
    var _k = React.useState([]), filterSelectedCLabs = _k[0], setSelectedFilterLabs = _k[1];
    var _l = React.useState(appConstants_1.defaultPageLimit), PageLimit = _l[0], setPageLimit = _l[1];
    var _m = React.useState(false), isDateRangeUpdated = _m[0], setIsDateRangeUpdated = _m[1];
    var _o = React.useState(false), isListReloaded = _o[0], setIsListReloaded = _o[1];
    var _p = React.useState(0), activeTab = _p[0], setActiveTab = _p[1];
    var _q = React.useState(false), isFilterButton = _q[0], setIsFilterButton = _q[1];
    var _r = React.useState(1), pageCount = _r[0], setpageCount = _r[1];
    var _s = React.useState(undefined), lifeCycleList = _s[0], setLifeCycleList = _s[1];
    var searchingHandler = function (event) {
        setSearchTerm(event.target.value.trim());
    };
    var bag_barcode_Handler = function (event) {
        setbagbarcode(event.target.value.trim());
    };
    var cashStatusHandler = function (cashstatus) {
        SetcashStatus(cashstatus);
    };
    var callBackOnDateRangeSelect = function (dateRangeArray) {
        if (dateRangeArray) {
            setStartDate(moment(dateRangeArray.start).format('YYYY-MM-DD'));
            setEndDate(moment(dateRangeArray.end).format('YYYY-MM-DD'));
            var fromDate = moment(dateRangeArray.start, 'YYYY-MM-DD');
            var toDate = moment(dateRangeArray.end, 'YYYY-MM-DD');
            var dayDiff = moment.duration(fromDate.diff(toDate)).asDays();
            if (Number(dayDiff.toString().split('-')[1]) > 2) {
                react_hot_toast_1.toast.error('Date range cannot exceed 3 days', {
                    duration: 4 * 1000,
                });
            }
        }
        else {
            setStartDate(null);
            setEndDate(null);
        }
        setIsDateRangeUpdated(!isDateRangeUpdated);
    };
    var fetchCities = function () { return __awaiter(void 0, void 0, void 0, function () {
        var stateIdArray, payloadToFetchCities;
        return __generator(this, function (_a) {
            stateIdArray = filterSelectedStates.map(function (state) { return state.id; });
            payloadToFetchCities = {
                state_id: stateIdArray,
            };
            (0, leavetracking_apicalls_1.fetchCitiesList)(payloadToFetchCities)
                .then(function (citiesListResponse) {
                var formattedCitiesList = (0, array_helpers_1.convertLabelAndValueCity)(citiesListResponse.cities);
                setCitiesData(formattedCitiesList);
            })
                .catch(function (e) {
                setCitiesData([]);
            });
            return [2];
        });
    }); };
    var callbackUpdateSelectedStates = function (value) {
        setCitiesData([]);
        setSelectedFilterCities([]);
        setSelectedFilterStates(value);
    };
    var callbackUpdateSelectedCities = function (value) {
        setSelectedFilterCities(value);
    };
    var navigateToMyReports = function () {
        dispatch((0, config_action_1.featchCurrentActiveMenu)({
            mainModule: menu_constants_1.FEATURE_CONSTANTS.reports,
            subModule: menu_constants_1.FEATURE_CONSTANTS.sub_my_reports,
            subChaildModule: '',
        }));
        navigate("/".concat(route_path_1.default.PATHS.MYREPORTS));
    };
    var FilterHandler = function () {
        setIsFilterButton(!isFilterButton);
    };
    var handlePageLimitChange = function (val) {
        setPageLimit(val);
    };
    var autoGenerateReportHandler = function () {
        var currentPage = pageCount < 1 ? 1 : pageCount;
        if (filterSelectedCLabs) {
            var payload = {};
            if (startDate && endDate) {
                var dateRangeArr = {
                    start_date: moment(startDate).format('YYYY-MM-DD'),
                    end_date: moment(endDate).format('YYYY-MM-DD'),
                };
                payload['date_range'] = dateRangeArr;
            }
            if (searchTerm) {
                payload['search_string'] = searchTerm;
            }
            if (bagbarcode) {
                payload['bag_barcode'] = bagbarcode;
            }
            if (activeTab === 1) {
                payload['is_lighter_version'] = true;
            }
            if (filterSelectedCities.length > 0) {
                var states_1 = [];
                var cities_1 = [];
                filterSelectedCities.map(function (selectedCityObj) {
                    cities_1.push(selectedCityObj.short_code);
                });
                filterSelectedStates.map(function (selectedStateObj) {
                    states_1.push(selectedStateObj.label);
                });
                payload['state'] = filterSelectedStates.length >= 30 ? ['ALL'] : states_1;
                payload['city'] = filterSelectedCities.length >= 500 ? ['ALL'] : cities_1;
            }
            if (filterSelectedCLabs.length > 0) {
                var labCode = (0, array_helpers_1.selecteAllOption)(filterSelectedCLabs, labList);
                payload['lab_code'] = labCode;
            }
            if (cashstatus) {
                payload['status'] = cashstatus.label;
            }
            payload['page'] = currentPage;
            payload['size'] = PageLimit ? parseInt(PageLimit.value.toString()) : 50;
            api_service_1.api_service
                .post({
                endPoint: api_service_1.api_service.api_urls.BAGGINGLIFECYCLE_AUTOGENERATENEW,
                payLoad: payload,
                domain: process.env.APPROVAL_BASEURL,
            })
                .then(function (res) {
                if (res.data.statusCode === 200) {
                    setOpen(true);
                }
                else {
                    react_hot_toast_1.toast.error(res.data.message);
                }
            })
                .catch(function (err) {
                react_hot_toast_1.toast.error(err.data.errors);
            });
        }
        else {
            react_hot_toast_1.toast.error('Please select Labcode');
        }
    };
    var labCodeChangeHandler = function (val) {
        setSelectedFilterLabs(val);
    };
    var activeTabChangeHandler = function (index) {
        if (activeTab !== index) {
            setActiveTab(index);
            setSearchTerm('');
            setbagbarcode('');
        }
    };
    React.useEffect(function () {
        if (filterSelectedStates.length >= 1) {
            fetchCities();
        }
    }, [filterSelectedStates]);
    return (React.createElement("div", { className: "fe-wrapper pay  -fe-wrapper" }, isHavingFeature ? (React.createElement(Pagenotfound_1.default, null)) : (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "tool-bar-wrapper" },
            React.createElement("div", { className: "page-heaidng" },
                React.createElement("h2", null, "Bagging Life Cycle")),
            React.createElement(button_component_1.default, { type: "button", buttonName: appConstants_1.reportDownload, color: "yellow-outline", isError: !features[menu_constants_1.FEATURE_CONSTANTS.bagReportDownload] && (lifeCycleList === null || lifeCycleList === void 0 ? void 0 : lifeCycleList.length) < 1, endIcon: "icon-import download-icon", onClickHandler: autoGenerateReportHandler })),
        React.createElement("div", { className: "filter-menu-wrapper mobile-view-filters" },
            React.createElement("div", { className: "filter-options mobile-view-filters" },
                React.createElement("div", { className: "search-filter" },
                    React.createElement(search_component_1.default, { placeholder: "Search ref_no,lab_no", searchHandler: searchingHandler, activetab: activeTab })),
                React.createElement("div", { className: "search-filter" },
                    React.createElement(search_component_1.default, { placeholder: "Bag Id", searchHandler: bag_barcode_Handler, activetab: activeTab })),
                React.createElement(multi_selector_1.default, { noOptions: 'No lab codes found', hasSelectAll: false, label: "Lab Code", dropDownList: labList &&
                        (0, array_helpers_1.convertLabcodeResponse)(labList).sort(function (a, b) {
                            return a.label.localeCompare(b.label);
                        }), onChangeHnadlre: labCodeChangeHandler, value: filterSelectedCLabs || [] }),
                React.createElement(drop_down_component_1.default, { name: "status", placeholder: "Status", dropDownList: CashStatus, onChange: cashStatusHandler, value: cashstatus || null, disableClearable: true }),
                React.createElement(text_filed_with_fromto_Daterange_1.default, { onChangeHandler: callBackOnDateRangeSelect, presentDate: true }),
                React.createElement(multi_selector_1.default, { label: "Select State", dropDownList: stateList && stateList.sort(function (a, b) { return a.label.localeCompare(b.label); }), onChangeHnadlre: callbackUpdateSelectedStates, value: filterSelectedStates }),
                React.createElement(multi_selector_1.default, { noOptions: 'No cities found', hasSelectAll: false, label: "Select City", dropDownList: citiesData && citiesData.sort(function (a, b) { return a.label.localeCompare(b.label); }), onChangeHnadlre: callbackUpdateSelectedCities, value: filterSelectedCities || [] }),
                React.createElement(drop_down_component_1.default, { dropDownList: appConstants_1.paginationDropdown, onChange: handlePageLimitChange, value: PageLimit }),
                React.createElement(button_component_1.default, { buttonName: "FILTERS", color: "yellow-outline", onClickHandler: FilterHandler }))),
        React.createElement("div", { className: "scrollable-content" },
            React.createElement(tabs_component_1.default, { tabList: filteredTabs, tabChangeHandler: activeTabChangeHandler }),
            React.createElement(react_router_dom_1.Routes, null,
                approvalManagSubRoutes &&
                    approvalManagSubRoutes.map(function (features) {
                        return (React.createElement(react_router_dom_1.Route, { index: true, path: "".concat(features.path), key: features.path, element: React.createElement(appConstants_1.ReloadListContext.Provider, { value: {
                                    isListReloaded: isListReloaded,
                                    setIsListReloaded: setIsListReloaded,
                                } },
                                React.createElement(features.component, { searchTerm: searchTerm, bagbarcode: bagbarcode, startDate: startDate, endDate: endDate, cashstatus: cashstatus, isFilterButton: isFilterButton, filterSelectedLabs: filterSelectedCLabs, filterSelectedCities: filterSelectedCities, PageLimit: PageLimit, setpageCount: setpageCount, pageCount: pageCount, setLifeCycleList: setLifeCycleList, lifeCycleList: lifeCycleList })) }));
                    }),
                React.createElement(react_router_dom_1.Route, { path: '*', element: React.createElement(Pagenotfound_1.default, null) }))),
        React.createElement(pop_up_1.default, { open: open },
            React.createElement("div", { className: "modal-header" },
                React.createElement("h2", { className: "heading" }, "Request Submitted"),
                React.createElement("h2", { className: "sub-heading" }, "Please view your report in My Reports section")),
            React.createElement("div", { className: "modal-footer sticky-modal-footer" },
                React.createElement(button_component_1.default, { buttonName: "Cancel", color: "yellow-outline", isError: false, onClickHandler: function () { return setOpen(false); } }),
                React.createElement(button_component_1.default, { buttonName: "My Reports", color: "yellow", onClickHandler: navigateToMyReports, isError: false })))))));
};
exports.default = BaggingLifeCycle;
